import Builder from '../../utils/redux/builder';

const builder = new Builder({
  name: 'modalsData',
  initialState: {
    modalsData: [],
  },
  reducers: {
    addIdToShowedModal(state, { payload }) {
      state.modalsData[0].id = payload;
    },
    removeShowedModal(state, { payload }) {
      state.modalsData = state.modalsData.filter((modal) => modal.id !== payload);
    },
    setCallbacks(state, { payload: { closeModalID } }) {
      state.closeModalID = closeModalID;
    },
    addModal(state, { payload: { type, props = {}, ...extraData } }) {
      if (!props.index || !state.modalsData.find((modal) => modal.props.index === props.index)) {
        state.modalsData.push({ type, props, extraData });
      }
    },
  },
});

const modalsData = builder.create().export();

export const { useModalsData: useModals } = modalsData.selectors;

export default modalsData;
